/* ============================================================
   Pepnerd — shared interactions (vanilla)
   tabs scrollspy · enquire modal · refs expander · helpful thumbs
   · sticky bar reveal
   ============================================================ */
(function(){
  'use strict';

  /* ---------- smooth scroll helper (no scrollIntoView) ---------- */
  function scrollToEl(el){
    if(!el) return;
    var tabsEl = document.querySelector('.tabs');
    var off = (tabsEl ? tabsEl.offsetHeight : 0) + 18; // tabs pin at top:0 (nav lifts away)
    var y = el.getBoundingClientRect().top + window.pageYOffset - off;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  /* ---------- tab pills + scrollspy + nav-lift (no double sticky) ---------- */
  function initTabs(){
    var tabs = Array.prototype.slice.call(document.querySelectorAll('.tab[data-target]'));
    if(!tabs.length) return;
    var sections = tabs.map(function(t){ return document.getElementById(t.dataset.target); }).filter(Boolean);
    var tabsEl = document.querySelector('.tabs');
    var main = document.querySelector('.main');
    var hdr = document.querySelector('.hdr');

    tabs.forEach(function(t){
      t.addEventListener('click', function(e){
        e.preventDefault();
        scrollToEl(document.getElementById(t.dataset.target));
      });
    });

    var ticking = false;
    function spy(){
      ticking = false;
      // hide the main nav while the chapter tabs are pinned (single sticky bar)
      if(hdr && tabsEl && main){
        var pinned = tabsEl.getBoundingClientRect().top <= 1;
        var pastMain = main.getBoundingClientRect().bottom <= 70;
        hdr.classList.toggle('hdr-lift', pinned && !pastMain);
      }
      var probe = (tabsEl ? tabsEl.offsetHeight : 0) + 90;
      var current = sections[0];
      for(var i=0;i<sections.length;i++){
        if(sections[i].getBoundingClientRect().top <= probe) current = sections[i];
      }
      tabs.forEach(function(t){ t.classList.toggle('active', current && t.dataset.target === current.id); });
    }
    window.addEventListener('scroll', function(){
      if(!ticking){ window.requestAnimationFrame(spy); ticking = true; }
    }, { passive:true });
    window.addEventListener('resize', spy, { passive:true });
    spy();
  }

  /* ---------- references expander ---------- */
  function initRefs(){
    var btn = document.querySelector('.refs-toggle');
    if(!btn) return;
    var more = document.querySelector('.refs-more');
    btn.addEventListener('click', function(){
      var open = more.classList.toggle('open');
      btn.classList.toggle('open', open);
      var n = btn.dataset.count || '';
      btn.querySelector('span').textContent = open ? 'Show fewer references' : ('View all references' + (n ? ' (' + n + ')' : ''));
    });
  }

  /* ---------- helpful thumbs ---------- */
  function initHelpful(){
    var wrap = document.querySelector('.helpful');
    if(!wrap) return;
    var btns = wrap.querySelectorAll('.thumb-btn');
    var thanks = wrap.querySelector('.thanks');
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        btns.forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
        if(thanks) thanks.style.display = 'inline';
      });
    });
  }

  /* ---------- size selector (enquiry rail) ---------- */
  function initSizes(){
    var sizes = document.querySelectorAll('.eq-size');
    sizes.forEach(function(s){
      s.addEventListener('click', function(){
        sizes.forEach(function(x){ x.classList.remove('on'); });
        s.classList.add('on');
        var input = document.getElementById('m-size');
        if(input) input.value = s.dataset.size || s.textContent.trim();
      });
    });
  }

  /* ---------- sticky bottom bar reveal after scroll ---------- */
  function initStickyBar(){
    var bar = document.querySelector('.stickybar');
    if(!bar) return;
    function upd(){
      var show = window.pageYOffset > 420;
      bar.classList.toggle('hide', !show);
    }
    window.addEventListener('scroll', upd, { passive:true });
    upd();
  }

  /* ---------- enquire modal ---------- */
  function initModal(){
    var scrim = document.getElementById('enquire-modal');
    if(!scrim) return;
    var form = scrim.closest('form') || document.getElementById('enquire-form-wrap');
    var successView = scrim.querySelector('.m-success');
    var formView = scrim.querySelector('.m-form');
    var lastFocus = null;

    function open(){
      lastFocus = document.activeElement;
      scrim.classList.add('open');
      document.body.style.overflow = 'hidden';
      var first = scrim.querySelector('input, select');
      if(first) setTimeout(function(){ first.focus(); }, 60);
    }
    function close(){
      scrim.classList.remove('open');
      document.body.style.overflow = '';
      if(lastFocus) lastFocus.focus();
      // reset to form after close animation
      setTimeout(function(){
        if(successView) successView.style.display = 'none';
        if(formView) formView.style.display = '';
      }, 220);
    }

    document.querySelectorAll('[data-enquire]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); open(); });
    });
    scrim.querySelectorAll('[data-close]').forEach(function(b){
      b.addEventListener('click', close);
    });
    scrim.addEventListener('click', function(e){ if(e.target === scrim) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && scrim.classList.contains('open')) close(); });

    if(form){
      form.addEventListener('submit', function(e){
        var ok = true;
        var name = form.querySelector('#m-name');
        var email = form.querySelector('#m-email');
        function mark(el, bad){
          el.classList.toggle('err', bad);
          var msg = el.parentNode.querySelector('.errmsg');
          if(msg) msg.classList.toggle('show', bad);
          if(bad) ok = false;
        }
        mark(name, !name.value.trim());
        var emv = email.value.trim();
        mark(email, !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(emv));
        if(!ok){ e.preventDefault(); return; }
        // Valid: show a loading state, then let the form POST natively to Shopify's
        // contact endpoint. The page reloads into the server-rendered success view
        // (form.posted_successfully). We do NOT fake success client-side.
        var btn = form.querySelector('button[type="submit"]');
        if(btn){
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          btn.classList.add('is-loading');
          btn.textContent = 'Sending…';
        }
      });
      // clear error on input
      form.querySelectorAll('.input').forEach(function(inp){
        inp.addEventListener('input', function(){
          inp.classList.remove('err');
          var msg = inp.parentNode.querySelector('.errmsg');
          if(msg) msg.classList.remove('show');
        });
      });
    }
  }

  /* ---------- catalogue filters ---------- */
  function initFilters(){
    var filters = document.querySelectorAll('.filter[data-filter]');
    if(!filters.length) return;
    var cards = document.querySelectorAll('.pcard[data-cats]');
    filters.forEach(function(f){
      f.addEventListener('click', function(){
        filters.forEach(function(x){ x.classList.remove('on'); });
        f.classList.add('on');
        var key = f.dataset.filter;
        cards.forEach(function(c){
          var show = key === 'all' || (' ' + c.dataset.cats + ' ').indexOf(' ' + key + ' ') > -1;
          c.style.display = show ? '' : 'none';
        });
      });
    });
  }

  /* ---------- dark footer: disclaimer toggle + newsletter ---------- */
  function initFooter(){
    var btn = document.querySelector('.mf-disc-btn');
    if(btn){
      var clamp = document.querySelector('.mf-legal');
      btn.addEventListener('click', function(){
        var open = clamp.classList.toggle('clamped') === false;
        btn.textContent = open ? 'Hide disclaimers' : 'Show disclaimers';
      });
    }
    var form = document.querySelector('.mf-form');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var ok = form.querySelector('.ok'); var inp = form.querySelector('input');
        if(inp && inp.value.trim()){ if(ok) ok.style.display='inline'; inp.value=''; }
      });
    }
  }

  /* ---------- tooltips: skip-delay once one is open ----------
     First tooltip waits (.4s CSS delay) to avoid accidental flashes. After it opens we add
     .tips-primed so adjacent info icons open instantly; a short grace keeps it primed while
     the pointer travels between them, then the delay returns. Works for hover and tap-focus. */
  function initTooltips(){
    var tips = document.querySelectorAll('.tip');
    if(!tips.length) return;
    var onT, offT;
    function enter(){
      clearTimeout(offT);
      onT = setTimeout(function(){ document.body.classList.add('tips-primed'); }, 450); // just past the .4s CSS show-delay, so the FIRST tip still fades in
    }
    function leave(){
      clearTimeout(onT);
      offT = setTimeout(function(){ document.body.classList.remove('tips-primed'); }, 500);
    }
    tips.forEach(function(t){
      t.addEventListener('mouseenter', enter);
      t.addEventListener('mouseleave', leave);
      t.addEventListener('focusin', enter);
      t.addEventListener('focusout', leave);
    });
  }

  /* ---------- mobile drawer: swipe-to-dismiss with momentum ----------
     The drawer enters from the right, so a rightward drag closes it. Velocity-based dismissal
     (a quick flick is enough); dragging left (deeper) meets damping, not a wall; axis-lock keeps
     vertical menu scrolling intact; multi-touch is ignored mid-drag. */
  function initDrawerSwipe(){
    var nav = document.getElementById('mnav');
    if(!nav) return;
    var panel = nav.querySelector('.mnav-panel');
    var scrim = nav.querySelector('.mnav-scrim');
    if(!panel) return;
    var x0=0, y0=0, t0=0, dx=0, axis=null, dragging=false, width=0;

    panel.addEventListener('touchstart', function(e){
      if(e.touches.length>1) return;                 // ignore extra fingers
      var t=e.touches[0];
      x0=t.clientX; y0=t.clientY; t0=Date.now();
      dx=0; axis=null; dragging=false; width=panel.offsetWidth||320;
    }, {passive:true});

    panel.addEventListener('touchmove', function(e){
      if(e.touches.length>1) return;
      var t=e.touches[0], ddx=t.clientX-x0, ddy=t.clientY-y0;
      if(axis===null){
        if(Math.abs(ddx)<6 && Math.abs(ddy)<6) return;
        axis = Math.abs(ddx)>Math.abs(ddy) ? 'x' : 'y';
        if(axis==='x'){ panel.style.transition='none'; dragging=true; }
      }
      if(axis!=='x') return;                          // vertical → let the menu scroll
      dx = ddx>0 ? ddx : ddx*0.18;                    // damp leftward over-drag
      panel.style.transform='translateX('+dx+'px)';
      if(scrim){ var p=Math.min(1,Math.max(0,dx/width)); scrim.style.opacity=String(1-p); }
    }, {passive:true});

    panel.addEventListener('touchend', function(){
      if(!dragging){ axis=null; return; }
      dragging=false;
      panel.style.transition='';                      // restore the .28s curve
      var dt=Date.now()-t0, vel=dx/Math.max(1,dt);    // px/ms, rightward positive
      if(dx > width*0.33 || vel > 0.45){              // flick or far enough → dismiss
        panel.style.transform='translateX(100%)';
        if(scrim) scrim.style.opacity='0';
        setTimeout(function(){
          nav.classList.remove('open');
          nav.setAttribute('aria-hidden','true');
          var b=document.querySelector('.hdr-burger'); if(b) b.setAttribute('aria-expanded','false');
          document.body.style.overflow='';
          panel.style.transform=''; panel.style.transition='';
          if(scrim) scrim.style.opacity='';
        }, 300);
      } else {                                        // snap back open
        panel.style.transform='';
        if(scrim) scrim.style.opacity='';
      }
      axis=null;
    }, {passive:true});
  }

  /* ---------- advocate carousel: dot nav (Lattice-style), click dot → scroll, active dot tracks scroll ---------- */
  function initAdvCarousel(){
    document.querySelectorAll('[data-vc-carousel]').forEach(function(car){
      var track = car.querySelector('.pvc2-track');
      if(!track) return;
      var dots = Array.prototype.slice.call(car.querySelectorAll('[data-vc-dot]'));
      var prev = car.querySelector('[data-vc-prev]'), next = car.querySelector('[data-vc-next]');
      function step(){ var c = track.querySelector('.vcc, .bcard'); var gap = parseFloat(getComputedStyle(track).columnGap) || 18; return (c ? c.offsetWidth : track.clientWidth/2) + gap; }
      function active(){ return Math.max(0, Math.min(dots.length-1, Math.round(track.scrollLeft / step()))); }
      function upd(){
        var a = active();
        dots.forEach(function(d,i){ d.classList.toggle('on', i===a); });
        if(prev) prev.disabled = track.scrollLeft <= 4;
        if(next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      dots.forEach(function(d,i){ d.addEventListener('click', function(){ track.scrollTo({ left:i*step(), behavior:'smooth' }); }); });
      if(prev) prev.addEventListener('click', function(){ track.scrollBy({ left:-step(), behavior:'smooth' }); });
      if(next) next.addEventListener('click', function(){ track.scrollBy({ left:step(), behavior:'smooth' }); });
      /* drag to scroll (mouse) — touch already scrolls natively */
      var dragging=false, startX=0, startL=0, moved=false;
      track.addEventListener('pointerdown', function(e){
        if(e.pointerType==='touch') return;
        if(track.scrollWidth <= track.clientWidth + 4) return;   /* not scrollable (e.g. desktop grid) → don't hijack clicks */
        dragging=true; moved=false; startX=e.clientX; startL=track.scrollLeft;
      });
      window.addEventListener('pointermove', function(e){
        if(!dragging) return;
        var dx=e.clientX-startX;
        if(Math.abs(dx)>4){ if(!moved){ moved=true; track.classList.add('is-grabbing'); } track.scrollLeft=startL-dx; }
      });
      window.addEventListener('pointerup', function(){
        if(!dragging) return; dragging=false; track.classList.remove('is-grabbing');
      });
      track.addEventListener('click', function(e){ if(moved){ e.preventDefault(); e.stopPropagation(); } }, true);
      track.addEventListener('scroll', upd, { passive:true });
      window.addEventListener('resize', upd, { passive:true });
      upd();
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initTabs();
    initAdvCarousel();
    initRefs();
    initHelpful();
    initSizes();
    initStickyBar();
    initModal();
    initFilters();
    initFooter();
    initTooltips();
    initDrawerSwipe();
  });
})();
